import { createSlice } from '@reduxjs/toolkit';
import { StatisticsState } from './StatisticsTypes';
import { getStatisticsOperation } from './statistics-operations';

const initialState: StatisticsState = {
  data: null,
  loading: false,
  error: null,
};

const statisticsSlice = createSlice({
  name: 'statistics',
  initialState,
  reducers: {
    resetStatistics: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(getStatisticsOperation.pending, s => {
      s.loading = true;
      s.error = null;
    });
    builder.addCase(getStatisticsOperation.fulfilled, (s, { payload }) => {
      s.data = payload;
      s.loading = false;
    });
    builder.addCase(getStatisticsOperation.rejected, (s, { payload, error }) => {
      s.loading = false;
      s.error = payload?.message || error.message || null;
    });
  },
});

export const { resetStatistics } = statisticsSlice.actions;
export default statisticsSlice.reducer;
